// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1bpce","content":"LoadingAlert_content__20HXb"};